import axios from "axios";
import {
    AlgorithmMode,
    IDynamicOrderBook,
    IMMBots,
    ISpread,
    IVolumeIncrease,
    LiquidBotsData,
    LiquidBotTrades
} from "../pages/inner/mmTypes";

const API_URL = "https://lukkypro.ru/api/v1/";

export const getUsers = async () => {
    const { data } = await axios.get(`${API_URL}users/get_user_list`, {
        headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` },
    });
    return data;
};

export const checkUser = async () => {
    const { data } = await axios.get(`${API_URL}auth/get_user`, {
        headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` },
    });
    return data;
};

export const getDynamicOrderBook = async (connectionId: string) => {
    const { data } = await axios.get<IDynamicOrderBook>(`${API_URL}dynamic_order_book/${connectionId}`, {
        headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` },
    });
    return data;
};

export const getSpread = async (connectionId: string) => {
    const { data } = await axios.get<ISpread>(`${API_URL}spreads/${connectionId}`, {
        headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` },
    });
    return data;
};

export const getVolumeIncrease = async (connectionId: string) => {
    const { data } = await axios.get<IVolumeIncrease>(`${API_URL}volume_increase/${connectionId}`, {
        headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` },
    });
    return data;
};

export const getMMBots = async (connectionId: string) => {
    const { data } = await axios.get<IMMBots>(`${API_URL}bots/${connectionId}`, {
        headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` },
    });
    return data;
};

export const setAlgorithmMode = async (
    connectionId: string,
    mode: AlgorithmMode,
    reason: string,
) => {
    const { data } = await axios.post<IMMBots>(
        `${API_URL}bots/${connectionId}/algorithm-mode`,
        { mode, reason },
        {
            headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` },
        },
    );
    return data;
};

export const getLiquidBots = async (connectionId: string, exchange: string, publicKey: string, secretKey: string, password: string) => {
    const { data } = await axios.get<LiquidBotsData>(`${API_URL}liquid_bots/${connectionId}`, {
        params: { trading_sdk_type: exchange, public_key: publicKey, secret_key: secretKey, password },
        headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` },
    });
    return data;
};

export const getTrades = async (connectionId: string, publicKey: string, privateKey: string, exchange: string, password: string) => {
    const { data } = await axios.get<LiquidBotTrades[]>(`${API_URL}liquid_bots/${connectionId}/get_all_orders`, {
        params: { trading_sdk_type: exchange, public_key: publicKey, secret_key: privateKey, password },
        headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` },
    });
    return data;
};

export const getBalance = async (connectionId: string, privateKey: string, publicKey: string, exchange: string, password: string) => {
    const { data } = await axios.get(`${API_URL}connections/${connectionId}/get_balance`, {
        params: { trading_sdk_type: exchange, public_key: publicKey, secret_key: privateKey, password },
        headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` },
    });
    return data;
};

export const cancelSingleOrder = async (connectionId: string, privateKey: string, publicKey: string, exchange: string, tradeId: string, password: string) => {
    const { data } = await axios.get(`${API_URL}liquid_bots/${connectionId}/${tradeId}/cancel_one_orders`, {
        params: { trading_sdk_type: exchange, public_key: publicKey, secret_key: privateKey, password },
        headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` },
    });
    return data;
};

export const cancelAllOrders = async (connectionId: string, privateKey: string, publicKey: string, exchange: string, password: string) => {
    const { data } = await axios.get(`${API_URL}connections/${connectionId}/cancel_all_orders`, {
        params: { trading_sdk_type: exchange, public_key: publicKey, secret_key: privateKey, password },
        headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` },
    });
    return data;
};
